module.exports = __webpack_public_path__ + "static/media/london-33.bc81a66c.jpg";